export const taxTableParams = (t) =>([
  {
    name: t('options.configurations.tax.range'),
    dataBase: 'taxRange',
  },
]);
